var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.viewLogsShow,
          expression: "viewLogsShow"
        }
      ],
      staticClass: "popup"
    },
    [
      !_vm.moreTransferFlag
        ? _c(
            "div",
            {
              staticClass: "content",
              style: { height: _vm.getHeight() },
              attrs: { id: "viewLogs" }
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\r\n            " +
                    _vm._s(_vm.$t("language.popup.taskListPopup.viewLogs")) +
                    "\r\n            "
                ),
                _c("div", {
                  staticClass: "icon white-close dialog-close",
                  on: {
                    click: function($event) {
                      return _vm.closePage()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _vm.singleTransferFlag
                  ? _c("div", { staticClass: "view-logs-body" }, [
                      _c("div", { staticClass: "log-line" }, [
                        _vm.viewDetail.tasks[0].type == 1
                          ? _c("div", { staticClass: "view-name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.cloudTransfer.transfer")
                                ) + ": "
                              )
                            ])
                          : _c("div", { staticClass: "view-name" }, [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.sync")) + ": "
                              )
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.viewDetail.tasks[0].branchType != "share",
                                expression:
                                  "viewDetail.tasks[0].branchType!='share'"
                              }
                            ],
                            staticClass: "log-category-link",
                            attrs: {
                              title: _vm._f("getCatalogTitle")(
                                _vm._f("getCatalog")(
                                  _vm.viewDetail.tasks[0].fromItem.nodes
                                )
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toSourceCatalog(
                                  _vm.viewDetail.tasks[0].fromItem
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getCatalog")(
                                  _vm.viewDetail.tasks[0].fromItem.nodes
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.viewDetail.tasks[0].branchType == "share",
                                expression:
                                  "viewDetail.tasks[0].branchType=='share'"
                              }
                            ],
                            staticClass: "log-category-link",
                            attrs: {
                              title: _vm._f("getCatalogTitle")(
                                _vm._f("getCatalogShare")(
                                  _vm.viewDetail.tasks[0].fromItem.nodes
                                )
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toSharelicLink(
                                  _vm.viewDetail.tasks[0].fromItem
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getCatalogShare")(
                                  _vm.viewDetail.tasks[0].fromItem.nodes
                                )
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "log-line" }, [
                        _vm.viewDetail.tasks[0].type == 1
                          ? _c("div", { staticClass: "view-name" }, [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.minTo")) + ": "
                              )
                            ])
                          : _c("div", { staticClass: "view-name" }, [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.with")) + ": "
                              )
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "log-category-link",
                            attrs: {
                              title: _vm._f("getCatalogTitle")(
                                _vm._f("getCatalog")(
                                  _vm.viewDetail.tasks[0].toItem.nodes
                                )
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toAimCatalog(
                                  _vm.viewDetail.tasks[0].toItem
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getCatalog")(
                                  _vm.viewDetail.tasks[0].toItem.nodes
                                )
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.showStatus(_vm.viewDetail.tasks[0]) == "failure"
                        ? _c("div", { staticClass: "log-line" }, [
                            _vm._v(
                              "\r\n                    " +
                                _vm._s(_vm.$t("language.common.result")) +
                                ": " +
                                _vm._s(_vm.$t("language.common.failure")) +
                                "\r\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(_vm.viewDetail.tasks[0]) == "patial"
                        ? _c("div", { staticClass: "log-line" }, [
                            _vm._v(
                              "\r\n                    " +
                                _vm._s(_vm.$t("language.common.result")) +
                                ": " +
                                _vm._s(_vm.$t("language.common.patial")) +
                                "\r\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(_vm.viewDetail.tasks[0]) == "success"
                        ? _c("div", { staticClass: "log-line" }, [
                            _vm._v(
                              "\r\n                    " +
                                _vm._s(_vm.$t("language.common.result")) +
                                ": " +
                                _vm._s(_vm.$t("language.common.success")) +
                                "\r\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(_vm.viewDetail.tasks[0]) == "cancel"
                        ? _c("div", { staticClass: "log-line" }, [
                            _vm._v(
                              "\r\n                    " +
                                _vm._s(_vm.$t("language.common.result")) +
                                ": " +
                                _vm._s(_vm.$t("language.common.canceled")) +
                                "\r\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "log-line" }, [
                        _vm.viewDetail.type == 2 &&
                        _vm.viewDetail.tasks[0].lastLog
                          ? _c("div", { staticClass: "log-line-sync" }, [
                              _vm._v(
                                "\r\n                        " +
                                  _vm._s(
                                    _vm.$t("language.common.fileProcess")
                                  ) +
                                  ": Add[" +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog.addFile
                                  ) +
                                  "] Update[" +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog.updateFile
                                  ) +
                                  "] Delete[" +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog.deleteFile
                                  ) +
                                  "]\r\n                    "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.viewDetail.type == 1 &&
                        _vm.viewDetail.tasks[0].lastLog
                          ? _c("div", { staticClass: "log-line-left" }, [
                              _vm._v(
                                "\r\n                        " +
                                  _vm._s(
                                    _vm.$t("language.common.fileProcess")
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog
                                      .readyTranFileCount
                                  ) +
                                  "/" +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog
                                      .totalFileCount
                                  ) +
                                  "\r\n                    "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.viewDetail.tasks[0].lastLog
                        ? _c("div", { staticClass: "log-line" }, [
                            _c("div", { staticClass: "log-line-left" }, [
                              _vm._v(
                                "\r\n                        " +
                                  _vm._s(
                                    _vm.$t("language.common.dataProcess")
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("formatByte")(
                                      _vm.viewDetail.tasks[0].lastLog
                                        .fileTotalReadedBytes
                                    )
                                  ) +
                                  "/" +
                                  _vm._s(
                                    _vm._f("formatByte")(
                                      _vm.viewDetail.tasks[0].lastLog.totalBytes
                                    )
                                  ) +
                                  "\r\n                    "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewDetail.tasks[0].lastLog
                        ? _c("div", { staticClass: "log-line" }, [
                            _c("div", { staticClass: "log-line-left" }, [
                              _vm._v(
                                "\r\n                        " +
                                  _vm._s(_vm.$t("language.common.startTime")) +
                                  ": " +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog
                                      .taskStartTimeStr
                                  ) +
                                  "\r\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.viewDetail.tasks[0].lastLog
                              ? _c("div", { staticClass: "log-line-right" }, [
                                  _vm._v(
                                    "\r\n                        " +
                                      _vm._s(
                                        _vm.$t("language.common.endTime")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm._f("getEndTime")(
                                          _vm.viewDetail.tasks[0].lastLog
                                        )
                                      ) +
                                      "\r\n                    "
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewDetail.tasks[0].lastLog
                        ? _c("div", { staticClass: "log-line" }, [
                            _c("div", { staticClass: "log-line-left" }, [
                              _vm._v(
                                "\r\n                        " +
                                  _vm._s(
                                    _vm.$t("language.common.averageRateSpecial")
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("formatByteSpeed")(
                                      _vm.viewDetail.tasks[0].lastLog
                                        .fileTotalReadedBytes /
                                        (_vm.viewDetail.tasks[0].lastLog
                                          .taskElaspedTimeLong /
                                          1000)
                                    )
                                  ) +
                                  "\r\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "log-line-right" }, [
                              _vm._v(
                                "\r\n                        " +
                                  _vm._s(
                                    _vm.$t("language.common.executedTimes")
                                  ) +
                                  ": " +
                                  _vm._s(_vm.viewDetail.tasks[0].runCount) +
                                  "\r\n                    "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewDetail.tasks[0].lastLog &&
                      _vm.viewDetail.tasks[0].lastLog.totalBytes &&
                      _vm.viewDetail.tasks[0].lastLog.fileTotalReadedBytes ==
                        _vm.viewDetail.tasks[0].lastLog.totalBytes
                        ? _c("div", { staticClass: "log-line" }, [
                            _vm._v(
                              "\r\n                    " +
                                _vm._s(_vm.$t("language.common.fileSuccess")) +
                                "\r\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewDetail.tasks[0].lastLog &&
                      _vm.viewDetail.tasks[0].lastLog.errorList.length
                        ? _c("div", { staticClass: "log-line" }, [
                            _c(
                              "div",
                              {
                                staticClass: "log-line-left click-log-red",
                                attrs: {
                                  title:
                                    _vm.viewDetail.tasks[0].lastLog.response
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openFailedFiles()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("language.common.viewFailed"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.viewDetail.type == 1 && !_vm.viewDetail.retryed
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "log-line-right click-log-blue",
                                    on: {
                                      click: function($event) {
                                        return _vm.retryAll()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("language.common.retryAll")
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.viewDetail.type == 1 && _vm.viewDetail.retryed
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "log-line-right click-log-blue",
                                    on: {
                                      click: function($event) {
                                        return _vm.toAimRootCatalog()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("language.common.viewProgress")
                                        )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm.showStatus(_vm.viewDetail.tasks[0]) == "failure"
                        ? _c(
                            "div",
                            {
                              staticClass: "log-line",
                              staticStyle: {
                                color: "red",
                                "margin-top": "10px"
                              }
                            },
                            [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(
                                    _vm.viewDetail.tasks[0].lastLog.response
                                  ) +
                                  "\r\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.loading
                ? _c("div", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "view-logs-body"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.nonFlag
                ? _c("div", { staticClass: "view-non-body" }, [
                    _vm._v(
                      "\r\n            " +
                        _vm._s(_vm.$t("language.common.taskNotRun")) +
                        "\r\n        "
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.moreTransferFlag
        ? _c("div", { staticClass: "content", attrs: { id: "viewLogs2" } }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\r\n            " +
                  _vm._s(_vm.$t("language.popup.taskListPopup.viewLogs")) +
                  "\r\n            "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: { click: _vm.closePage }
              })
            ]),
            _vm._v(" "),
            _vm.loading
              ? _c("div", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "view-logs-body"
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "view-logs-all" }, [
              _c(
                "div",
                { staticClass: "view-logs-body" },
                _vm._l(_vm.viewDetail.tasks, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "logs-detail-box progress-box-height",
                      class: _vm.getHeight(item, index)
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "view-logs-info" },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "210Px", float: "left" } },
                            [
                              _c("div", { staticClass: "view-logs-catelog" }, [
                                _c("div", { staticStyle: { float: "left" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.common.from")) + ":"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.branchType != "share" &&
                                          item.branchType != "businessTransfer",
                                        expression:
                                          "item.branchType!='share'&& item.branchType!='businessTransfer'"
                                      }
                                    ],
                                    staticClass: "view-logs-category-link",
                                    attrs: {
                                      title: _vm._f("getCatalogTitle")(
                                        _vm._f("getCatalog")(
                                          item.fromItem.nodes
                                        )
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.toSourceCatalog(
                                          item.fromItem
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getCatalog")(
                                          item.fromItem.nodes
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.branchType == "businessTransfer",
                                        expression:
                                          "item.branchType=='businessTransfer'"
                                      }
                                    ],
                                    staticClass: "view-logs-category-link",
                                    attrs: { title: item.fromItem.fromEmail },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.toSourceCatalog(
                                          item.fromItem
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.fromItem.fromEmail))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.branchType == "share",
                                        expression: "item.branchType=='share'"
                                      }
                                    ],
                                    staticClass: "view-logs-category-link",
                                    attrs: {
                                      title: _vm._f("getCatalogTitle")(
                                        _vm._f("getCatalogShare")(
                                          item.fromItem.nodes
                                        )
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.toSharelicLink(item.fromItem)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getCatalogShare")(
                                          item.fromItem.nodes
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              item.type == 1
                                ? _c(
                                    "div",
                                    { staticClass: "view-logs-catelog" },
                                    [
                                      item.branchType != "businessTransfer"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: { float: "left" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("language.common.to")
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "view-logs-category-link",
                                                attrs: {
                                                  title: _vm._f(
                                                    "getCatalogTitle"
                                                  )(
                                                    _vm._f("getCatalog")(
                                                      _vm.toNodes
                                                    )
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toAimCatalog(
                                                      item.toItem
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("getCatalog")(
                                                      _vm.toNodes
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: { float: "left" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("language.common.to")
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "view-logs-category-link",
                                                attrs: {
                                                  title: item.toItem.toEmail
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toAimCatalog(
                                                      item.toItem
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.toItem.toEmail)
                                                )
                                              ]
                                            )
                                          ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.type == 2
                                ? _c(
                                    "div",
                                    { staticClass: "view-logs-catelog" },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { float: "left" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.common.with")
                                            ) + ":"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "view-logs-category-link",
                                          attrs: {
                                            title: _vm._f("getCatalogTitle")(
                                              _vm._f("getCatalog")(
                                                item.toItem.nodes
                                              )
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toAimCatalog(
                                                item.toItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getCatalog")(
                                                item.toItem.nodes
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "210Px",
                                float: "left",
                                height: "100%"
                              }
                            },
                            [
                              _vm.showStatus(item) == "success"
                                ? _c("div", [
                                    _c("div", {
                                      staticClass:
                                        "icon-util task-success logs-failure-icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { float: "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.success")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showStatus(item) == "failure"
                                ? _c("div", [
                                    _c("div", {
                                      staticClass:
                                        "icon-util task-failure logs-failure-icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { float: "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.failure")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showStatus(item) == "patial"
                                ? _c("div", [
                                    _c("div", {
                                      staticClass:
                                        "icon-util task-patial logs-status-icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { float: "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.patial")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showStatus(item) == "cancel"
                                ? _c("div", [
                                    _c("div", {
                                      staticClass:
                                        "icon-util task-failure logs-status-icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { float: "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.canceled")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div"),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "icon-util  view-collapse-positopn",
                            class:
                              _vm.clickCurrent == index
                                ? "collapse-up"
                                : "collapse-down",
                            on: {
                              click: function($event) {
                                return _vm.collapse(index, item)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("viewlogsDetail", {
                            ref: "viewlogsDetail",
                            refInFor: true,
                            attrs: {
                              clickCurrent: _vm.clickCurrent,
                              index: index,
                              itemDetail: item
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a10f424a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a10f424a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/view_logs_popups.vue
// module id = null
// module chunks = 